define('appkit/interceptor.manager',['require','exports','module','underscore','marionette','bluebird'],function(require, exports, module) {
  var _       = require('underscore');
  var Mn      = require('marionette');
  var Promise = require('bluebird');

  var InterceptorManager = Mn.Object.extend({

    initialize: function() {
      this.interceptors = [];
    },

    register: function(interceptor, context) {
      if (this.canRegister(interceptor)) {
        this.interceptors.push({
          interceptor: interceptor,
          context: context
        });
      }
    },

    canRegister: function(interceptor) {
      return _.isFunction(interceptor);
    },

    invokeInterceptor: function(interceptor, context) {
      return interceptor.call(context || this);
    },

    start: function() {
      if (_.isEmpty(this.interceptors)) {
        return Promise.resolve();
      }
      var promises = _.map(this.interceptors, function(interceptorWrapper) {
        return this.invokeInterceptor(interceptorWrapper.interceptor, interceptorWrapper.context);
      }, this);
      return Promise.all(promises);
    }

  });

  module.exports = InterceptorManager;
});
